export default [
	{ id: 1, name: 'SUN' },
	{ id: 2, name: 'MON' },
	{ id: 3, name: 'TUE' },
	{ id: 4, name: 'WED' },
	{ id: 5, name: 'THU' },
	{ id: 6, name: 'FRI' },
	{ id: 7, name: 'SAT' },
]